// extracted by mini-css-extract-plugin
export default {"DashboardPage":"styles_DashboardPage__JUIdP","container":"styles_container__2C69k","mobile":"styles_mobile__Wl99x"};